module.exports = __webpack_public_path__ + "img/full4-min.58cd6f21.png";